<capra-toast
  class="progress-toast"
  type="processing"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <h4 class="toast-header">Publishing Dataset in Data Workspace...</h4>
  <p class="toast-text">Stay on this page to be notified when the data is ready to use.</p>
</capra-toast>
